import axios from "axios";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Header1 from "./Header1";
import Footer from "./Footer";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Login = () => {
  const [adminId, setAdminId] = useState("");
  const [password, setPassword] = useState("");
  const [showPopup, setShowPopup] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!adminId || !password) {
      toast.warning("Please enter ID and Password", { position: "top-center" });
      return;
    }

    try {
      const response = await axios.post("https://api.bigfresh.in/login", {
        adminId,
        password,
      });

      if (response.data.user_id === "BM1001") {
        localStorage.setItem("isLoggedIn", "true");
        localStorage.setItem("userData", JSON.stringify(response.data));

        toast.success("Login successful ", { position: "top-center" });
        setShowPopup(true);

        setTimeout(() => {
          setShowPopup(false);
          navigate("/dashboard");
          window.location.reload();
        }, 1500);
      } else {
        toast.error("Invalid Admin ID or Password");
      }
    } catch (error) {
      console.error(error.response?.data || error);
      toast.error("Login failed. Please try again.", { position: "top-center" });
    }
  };

  return (
    <>
      <Header1 />

      {/* Banner Section */}
      <div
        className="d-flex flex-column justify-content-center align-items-center text-center position-relative"
        style={{ height: "400px", overflow: "hidden", padding: "0 20px" }}
      >
        <div
          style={{
            position: "absolute",
            inset: 0,
            backgroundImage:
              "url('https://plus.unsplash.com/premium_photo-1664527305901-a3c8bec62850')",
            backgroundSize: "cover",
            backgroundPosition: "center",
            opacity: 0.4,
            zIndex: 0,
          }}
        />
        <div style={{ position: "relative", zIndex: 1 }}>
          <h1 className="fw-bold text-black">Login</h1>
        </div>
      </div>

      {/* Login Card */}
      <div className="d-flex justify-content-center my-5">
        <div
          className="card shadow-lg p-4"
          style={{ width: "100%", maxWidth: "400px", position: "relative" }}
        >


          <h3 className="text-center mb-4">Login</h3>

          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label">ID</label>
              <input
                type="text"
                className="form-control"
                value={adminId}
                onChange={(e) => setAdminId(e.target.value)}
                placeholder="Enter ID"
                required
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Password</label>
              <input
                type="password"
                className="form-control"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter Password"
                required
              />
            </div>

            <button type="submit" className="btn btn-success w-100">
              Login
            </button>

             <div className="text-center mb-2 text-muted">
    — or —
  </div>

              <div className="text-center">
    <span className="me-1">New user?</span>
    <a href="/register" className="text-primary fw-semibold">
      Create an account
    </a>
  </div>
          </form>
        </div>
      </div>

      <Footer />

      {/* 🔔 Toast Container */}
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
      />
    </>
  );
};

export default Login;
